// One stroke-icon set, so nothing renders as a colour emoji next to a text
// glyph. All 24-grid, 1.6 stroke, currentColor — they inherit whatever the
// surrounding text is doing.

const P = {
  chevronLeft: 'M15 5l-7 7 7 7',
  chevronRight: 'M9 5l7 7-7 7',
  today: 'M12 7v5l3 2M12 3a9 9 0 100 18 9 9 0 000-18z',
  days: 'M4 7h16M4 12h16M4 17h10',
  doc: 'M14 3v5h5M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8l-5-5z',
  euro: 'M17 8a5.5 5.5 0 100 8M6 11h7M6 14h7',
  more: 'M4 7h16M4 12h16M4 17h16M8 7v10',
  phone: 'M4 5c0 8 7 15 15 15l2-3-4-2-2 2c-3-1-6-4-7-7l2-2-2-4-4 1z',
  pin: 'M12 21s7-6 7-11a7 7 0 10-14 0c0 5 7 11 7 11zM12 10h.01',
  clip: 'M9 13l5-5a3 3 0 014 4l-7 7a4 4 0 01-6-6l7-7',
  camera: 'M4 8h3l1.5-2h7L17 8h3v11H4V8zM12 16a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4z',
  plus: 'M12 6v12M6 12h12',
  trash: 'M4 7h16M10 4h4M9.5 7l.6 12h3.8l.6-12M6.5 7l.8 13h9.4l.8-13',
  alert: 'M12 9v4M12 17h.01M10.3 4.3L2.8 17a2 2 0 001.7 3h15a2 2 0 001.7-3L14.7 4.3a2 2 0 00-3.4 0z',
  clock: 'M12 8v4l3 2M12 3a9 9 0 100 18 9 9 0 000-18z',
  check: 'M5 12.5l4.5 4.5L19 7',
  plane: 'M3 14l18-6-6 12-2-5-5-2z',
  bed: 'M3 18v-6h18v6M3 12V7M7 12V9h6a2 2 0 012 2v1',
  star: 'M12 4l2.4 5 5.6.8-4 4 1 5.6L12 16.8 7 19.4l1-5.6-4-4 5.6-.8z',
  cup: 'M5 8h11v4a5 5 0 01-5 5H10a5 5 0 01-5-5V8zM16 9h2a2 2 0 010 4h-2',
  note: 'M12 8v.01M12 11v5M12 3a9 9 0 100 18 9 9 0 000-18z',
  logout: 'M15 12H4m4-4l-4 4 4 4M14 5h4a2 2 0 012 2v10a2 2 0 01-2 2h-4',
  offline: 'M12 19h.01M5 12a10 10 0 0114 0M8.5 15.5a6 6 0 017 0',
  // An open book: the diary, and the only glyph here that means "already
  // happened" rather than "planned".
  book: 'M12 7c-1.8-1.3-4-1.8-8-1.8v12.6c4 0 6.2.5 8 1.8m0-12.6c1.8-1.3 4-1.8 8-1.8v12.6c-4 0-6.2.5-8 1.8m0-12.6v12.6',
  google: null,   // rendered as a filled mark, not a stroke path
};

export default function Icon({ name, size = 18, className, style }) {
  if (name === 'google') {
    // Google requires its own mark rather than a monochrome approximation.
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true"
           className={className} style={style}>
        <path fill="#4285F4" d="M23 12.3c0-.8-.1-1.6-.2-2.3H12v4.4h6.2a5.3 5.3 0 01-2.3 3.5v2.9h3.7c2.1-2 3.4-5 3.4-8.5z"/>
        <path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.8-3a7 7 0 01-4.1 1.2 7.4 7.4 0 01-7-5.1H1.3v3A12 12 0 0012 24z"/>
        <path fill="#FBBC05" d="M5 14.2a7.4 7.4 0 010-4.6V6.7H1.3a12 12 0 000 10.6l3.7-3z"/>
        <path fill="#EA4335" d="M12 4.7c1.8 0 3.4.6 4.6 1.8l3.4-3.4A11.5 11.5 0 0012 0 12 12 0 001.3 6.7l3.7 3A7.4 7.4 0 0112 4.7z"/>
      </svg>
    );
  }

  const d = P[name];
  if (!d) return null;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"
         strokeLinejoin="round" aria-hidden="true" className={className} style={style}>
      <path d={d} />
    </svg>
  );
}

// Each event kind gets a glyph as well as a colour, so the distinction survives
// for anyone who cannot rely on hue alone.
export const KIND_ICON = {
  transport: 'plane',
  lodging: 'bed',
  activity: 'star',
  meal: 'cup',
  note: 'note',
  admin: 'doc',
};
